import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { ResizeObserver } from "@juggle/resize-observer";
import useMeasure from "react-use-measure";
export default function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return useMeasure(_object_spread_props(_object_spread({}, options), {
        polyfill: ResizeObserver
    }));
};
